import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import PublicLayout from 'components/Layouts/public'
// import { LoaderContext } from 'context/loader'
import usePost from 'hooks/usePost'
import APIS from 'constants/api'
import { useTheme } from 'context/themeContext'
import PdpDetailView from 'views/PdpDetailView'
import SimilarProducts from 'views/SimilarProducts'
import { CommonStyle } from 'styles/pages/Common'
import { PdpMainWrapper } from 'styles/views/PdpDetailView'
import { useHomeContext } from 'context/HomeContext'
import NotFound from 'components/NotFound'
import TagManager from 'react-gtm-module'
import useGet from 'hooks/useGet'
import { updateDynamicHeaders } from 'services/axiosInstance'

const PdpPage = () => {
  const [productDetails, setProductDetails] = useState<any>({})
  const [similarProductDetails, setSimilarProductDetails] = useState([])
  // const { setLoader } = useContext(LoaderContext)
  const { mutateAsync } = usePost()
  const [productNotFound, setProductNotFound] = useState(false)
  const { setHomeData } = useHomeContext()
  // const customerId = localStorage.getItem('customerId')
  const param: any = useParams()
  const productId = param?.id
  const [widgetDetails, setWidgetDetails] = useState<any>()
  const { themedata, storesData } = useTheme()
  const [similarProductWidgets, setSimilarWidget] = useState<any>([])
  const [vendorProducts, setVendorProducts] = useState<any>([])
  // const widgetDetails = themedata?.d?.objectDetails?.productView?.widgetId
  // console.log(widgetDetails)
  // console.log('🚀 ~ PdpPage ~ widgetDetails:', widgetDetails[0]?.widgetId)

  // const widgetDetails = themedata?.d?.objectDetails?.productView?.widgetId?.[0]
  // const similarProductWidgets = widgetDetails
  //   ? widgetDetails?.filter((widget: any) => widget.widgetType === 'similar_products')
  //   : []

  // console.log('similarProductWidgets', similarProductWidgets)
  useEffect(() => {
    if (themedata?.d?.objectDetails?.productView?.widgetId) {
      setWidgetDetails(themedata?.d?.objectDetails?.productView?.widgetId)
    }
  }, [themedata])

  useEffect(() => {
    setSimilarWidget(
      widgetDetails ? widgetDetails?.filter((widget: any) => widget.widgetType === 'similar_products') : [],
    )
    setVendorProducts(
      widgetDetails ? widgetDetails?.filter((widget: any) => widget.widgetType === 'vendor_products') : [],
    )
  }, [widgetDetails])

  // const fetchData = async (pageUrl: string) => {
  //   //setLoader(true)
  //   try {
  //     const res = await mutateAsync({
  //       url: APIS.PRODUCT_DETAIL,
  //       payload: {
  //         productId,
  //         customerId,
  //         productUrl: pageUrl,
  //       },
  //     })
  //     if (res) {
  //       setProductDetails(res?.d)
  //       //setLoader(false)
  //       setProductNotFound(false)
  //     }
  //   } catch (error) {
  //     //setLoader(false)
  //     // router.push(NotFoundRoute.path)
  //     setProductNotFound(true)
  //   }
  // }

  const { refetch, data } = useGet('fetchData', `${APIS.PRODUCT_DETAIL_V1}`)

  useEffect(() => {
    if (data?.s == 1) {
      setProductDetails(data?.d)
      setProductNotFound(false)
    } else if (data?.s == 0) {
      setProductNotFound(true)
    }
  }, [data])

  const fetchSimilarData = async () => {
    //setLoader(true)
    try {
      const res = await mutateAsync({
        url: APIS.VENDOR_PRODUCT,
        payload: { sellerId: productDetails?.sellerId },
      })
      if (res) {
        setSimilarProductDetails(res?.d?.products)
        //setLoader(false)
      }
    } catch (error) {
      //setLoader(false)
    }
  }

  const getWidgetProducts = async () => {
    //setLoader(true)
    try {
      const res = await mutateAsync({
        url: APIS.GET_WIDGET_PRODUCT,
        payload: { widgetId: widgetDetails[0]?.widgetId, productId },
      })
      if (res) {
        setSimilarProductDetails(res?.d?.products)
        //setLoader(false)
      }
    } catch (error) {
      //setLoader(false)
    }
  }

  useEffect(() => {
    const productName = productDetails?.productName?.replace(/[^a-zA-Z0-9]/g, ' ').trim()
    //process.env.PUBLIC_URL+productDetails?.imgUrl
    let imageUrl =
      productDetails?.imgUrl?.includes('https://') || productDetails?.imgUrl?.includes('http://')
        ? productDetails?.imgUrl
        : `https://cdnaz.plotch.io/image/upload/w_500${productDetails?.imgUrl}`
    if (imageUrl.includes('cdnaz.plotch.io')) {
      imageUrl = imageUrl.includes('w_') ? imageUrl : imageUrl.split('upload/').join('upload/w_500/')
    }

    const seoDetails = {
      robots: productDetails?.seoDetails?.metaRobots,
      pageTitle: `Buy ${productName} Online | ${storesData?.d?.storefrontName}`,
      metaKeywords: `${productName} | ${productName} Online Shopping`,
      imgUrl: `${imageUrl}`,
      url: `${window.location.href}`,
    }
    setHomeData(seoDetails)
  }, [productDetails])

  useEffect(() => {
    const customHeader = {
      productId: productId,
    }
    updateDynamicHeaders(customHeader)
    const path = location.pathname.split('/').pop()
    // const plotchDomain =
    //   process.env.NODE_ENV == 'production' && process.env.REACT_APP_ENV == ''
    //     ? window.location.hostname
    //     : process.env.REACT_APP_PLOTCH_DOMAIN
    if (path) {
      // fetchData(`http://${plotchDomain}/${path}`)
      refetch()
    }
  }, [productId])

  useEffect(() => {
    if (
      storesData?.d?.ondcEnabled == 1 &&
      themedata?.d?.objectDetails?.productView?.widgetId &&
      vendorProducts[0]?.widgetType == 'vendor_products'
    ) {
      if (productDetails?.sellerId) {
        fetchSimilarData()
      }
    } else if (
      widgetDetails?.length > 0 &&
      widgetDetails[0]?.widgetId &&
      similarProductWidgets[0]?.widgetType == 'similar_products'
    ) {
      getWidgetProducts()
    }
  }, [productDetails, widgetDetails, similarProductWidgets.length])

  useEffect(() => {
    const dataToPush = {
      event: 'ViewContent',
      eventName: 'ViewContent',
      source: 'productDetailsPage',
      content_type: 'Product',
      productId,
      productPrice: productDetails?.regularPrice,
      prodName: productDetails?.productName,
      currency: 'INR',
    }

    // Push data to the data layer using TagManager
    TagManager.dataLayer({ dataLayer: dataToPush })
  }, [productDetails])

  return (
    <PublicLayout>
      {/* <GoogleTagManager
        event="ViewContent"
        additionalData={{
          event: 'ViewContent',
          eventName: 'ViewContent',
          source: 'productDetailsPage',
          content_type: 'Product',
          productId,
          productPrice: productDetails?.regularPrice,
          prodName: productDetails?.productName,
          currency: 'INR',
        }}
      /> */}
      <CommonStyle>
        <PdpMainWrapper>
          {!productNotFound && Object.values(productDetails).length > 0 && (
            <PdpDetailView productDetails={productDetails} similarProductDetails={similarProductDetails} />
          )}
          {!productNotFound && similarProductDetails?.length > 0 && (
            <SimilarProducts products={similarProductDetails} />
          )}
          {productNotFound && <NotFound />}
        </PdpMainWrapper>
      </CommonStyle>
    </PublicLayout>
  )
}

export default PdpPage
